import styled from 'styled-components';

export const ContactCardList = styled.ul`
  display: flex;
  padding: 0;
  flex-wrap: wrap;
  @media (min-width: 480px) {
    flex-basis: 48%;
    justify-content: space-between;
  }
`;

export const ContactCardListItem = styled.li`
  list-style-type: none;
  flex-basis: 100%;
  margin-bottom: 1rem;
  @media (min-width: 480px) {
    flex-basis: 48%;
  }
  @media (min-width: 768px) {
    flex-basis: 32%;
  }
  @media (min-width: 992px) {
    flex-basis: 24%;
    flex-basis: ${(props) => (props.itensCount === 4 ? '24%' : '32%')};
  }
`;
